import diabetes_medicines from "./diabetes_medicines.svg";
import blood_thinners from "./blood_thinners.svg";
import bloodPressureMedicines from "./bloodPressureMedicines.svg";
import nutritional_supplement from "./nutritional_supplement.svg";
import colonoscopy_before from "./colonoscopy_before.jpg";

const questionnaireImages = {
  diabetesMedicines: diabetes_medicines,
  bloodThinners: blood_thinners,
  bloodPressureMedicines: bloodPressureMedicines,
  nutritionalSupplement: nutritional_supplement,
  colonoscopyBefore: colonoscopy_before,
};

export default questionnaireImages;
